import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "./overrides.scss";

toast.configure({
    autoClose: 5000,
    toastClassName: "toast",
    progressClassName: "toast__progress",
});
